import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { STPackage } from './STPackage.js';
export class OrganizationPackagesStatus extends AutoEncoder {
    packages;
}
__decorate([
    field({ decoder: new ArrayDecoder(STPackage) })
], OrganizationPackagesStatus.prototype, "packages", void 0);
//# sourceMappingURL=OrganizationPackagesStatus.js.map